const customerRouters = [
  // 客户管理
  {
    path: 'customer',
    name: 'Customer',
    redirect: '/manage/system/customer/list',
    component: () => import(/* webpackChunkName: "CustomerMain" */ '@/views/content'),
    meta: {
      sidebar: 2,
      authKey: ['auth_customer'],
      title: 'com_sider_menu_customer',
      disabled: false,
      icon: 'menu_customer2',
    },
    children: [
      {
        path: 'list',
        name: 'CustomerList',
        component: () =>
          import(/* webpackChunkName: "Customer" */ '@/views/system/customer/list.vue'),
        meta: {
          sidebar: false,
          breadcrumb: false,
          authKey: ['auth_customer', 'auth_customer_list'],
          title: 'com_sider_menu_customer',
          disabled: false,
          icon: 'menu_customer2',
        },
      },
      {
        path: 'detail/:id',
        name: 'CustomerDetail',
        component: () =>
          import(/* webpackChunkName: "Customer" */ '@/views/system/customer/detail.vue'),
        meta: {
          sidebar: false,
          authKey: ['auth_customer', 'auth_customer_detail'],
          title: 'com_sider_menu_customer_detail',
          disabled: false,
          icon: 'menu_customer2',
          autoCollect: false,
        },
      },
    ],
  },
];

export default customerRouters;
